module.exports = __webpack_public_path__ + "img/golf-ball-tee.b0cd7851.svg";